import ViewColumnSharpIcon from '@mui/icons-material/ViewColumnSharp';
import { Alert, Badge, CardActions, CardContent, CardHeader, IconButton, Snackbar } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import MoreOptionsModal from '../modal/MoreOptionsModal';
import { useEffect, useState } from 'react';
import NFTAvatar from '../avatar/NFTAvatar';
import ViewOGBadge from '../avatar/ViewOGBadge';
import { ReplyMessageMenue } from '../../services/chime';
import { isUserSignedIn, authenticatedUserAddress } from '../../services/auth';
import { clientNetwork } from '../../lib/constants';
import ReplyChimeModal from '../modal/ReplyChimeModal';
import GiftingModal from '../modal/GiftingModal';
import SharingModal from '../modal/SharingModal';
import ComingSoonModal from '../modal/ComingSoonModal';
import AdvisoryModal from '../../components/modal/AdvisoryModal';
import { BiGift, BiShareAlt, BiBarChart } from 'react-icons/bi';
import "./style.scss";
import Attachments from './Attachments';
import Content from './Content';
import ExtensionModal from '../modal/ExtensionModal';
import { SentimentMenue } from '../../services/chime/Sentiments';
import Avatar from '../customavatar';

const ChimeCard = ({
    index,
    storageUrl,
    setStorageUrl,

    contenttxId,
    authorPrincipal, authorName,
    replyTxId,
    content,
    // Attachments
    attachmentUrl, thumbnailUrl,
    imageType, audioType, videoType,
    // Sentiment
    likeCount, disLikeCount, replyCount,
    liked, disliked, impressions, replied,

    setReplyOpen,
    threading,

    // MediaPlayer Handlers
    playList, setPlayList, mediaCurrentTime,
    openMediaPlayer, setOpenMediaPlayer,
    // currentTime, setCurrentTime,

    userSettings,
    selectedChimeTx, setSelectedChimeTx,

    setShowUserContractDeployModal,
    setShowWoopsModal,
    setOpenConfirmModal,
    userContractStatus,

    txId,
    setTxId,
    tx_Id,
    setTx_Id

}) => {
    // Chime Data State
    const [selectedTxId, setSelectedTxId] = useState(null);

    // Modal State
    const [showMoreOptionsModal, setShowMoreOptionsModal] = useState(false);
    const [showReplyChimeModal, setShowReplyChimeModal] = useState(false);
    const [showGiftingModal, setShowGiftingModal] = useState(false);
    const [showSharingModal, setShowSharingModal] = useState(false);
    const [showComingSoonModal, setShowComingSoonModal] = useState(false);
    const [openExtensionModal, setOpenExtensionModal] = useState(false);
    const [showAdvisoryModal, setShowAdvisoryModal] = useState(false);

    const [loadOutData, setLoadOutData] = useState(null);

    // Misc State
    const [sentimentOptions, setSentimentOptions] = useState({});
    const [openSnackBar, setOpenSnackBar] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [selectedAuthorPrincipal, setSelectedAuthorPrincipal] = useState('');

    // Extras state
    const [extrasValues, setExtrasValues] = useState({});
    // Extension action indicate state
    const [extensionAction, setExtensionAction] = useState('');

    function validate(open, value) {
        console.log({ userContractStatus });
        switch (userContractStatus) {
            case true:
                open(value);
                break;
            case false:
            case 'success':
            case 'mempool':
            case 'abort_by_post_condition':
            case 'abort_by_response':
                setShowUserContractDeployModal(true);
                break;
            case 'updateNeeded':
                setShowAdvisoryModal(true);
                break;
            default:
                if (isUserSignedIn()) {
                    setShowUserContractDeployModal(true);
                } else {
                    setShowWoopsModal(true);
                }
                break;
        }
    }

    //Gift Click Handler
    const handleGiftClick = async (authorPrincipal, Tx_ID) => {
        //const authedUser = getUserData().profile.stxAddress.testnet;
        const authedUser = authenticatedUserAddress({ network: clientNetwork });
        console.log("p3 automagic networking: " + authedUser);

        if (authedUser === authorPrincipal) {
            setErrorMsg("Interacting with your own content is not possible");
            setOpenSnackBar(true);
            return null
        }
        setSelectedAuthorPrincipal(authorPrincipal);
        setTxId(Tx_ID);
        validate(setShowGiftingModal, true);
    };

    //Share Click Handler
    const handleShareClick = (txId) => {
        setSelectedTxId(txId);
        setShowSharingModal(true);
    };

    //More Options Click Handler
    const handleMoreOptionsClick = (txId, authorPrincipal) => {
        setSelectedTxId(txId);
        setSelectedAuthorPrincipal(authorPrincipal);
        setShowMoreOptionsModal(true);
    }

    //Linkage to Profile Click Handler
    const redirectToProfile = (val) => {
        window.location.replace(`/${val}`)
    }

    function formatNumber(num) {
        if (num < 1000) {
            return num.toString();
        } else if (num < 1000000) {
            let formattedNum = (num / 1000).toFixed(num % 1000 === 0 ? 0 : 1);
            return formattedNum.endsWith('.0') ? formattedNum.slice(0, -2) + 'K' : formattedNum + 'K';
        } else if (num < 1000000000) {
            let formattedNum = (num / 1000000).toFixed(num % 1000000 === 0 ? 0 : 1);
            return formattedNum.endsWith('.0') ? formattedNum.slice(0, -2) + 'M' : formattedNum + 'M';
        } else {
            let formattedNum = (num / 1000000000).toFixed(num % 1000000000 === 0 ? 0 : 1);
            return formattedNum.endsWith('.0') ? formattedNum.slice(0, -2) + 'B' : formattedNum + 'B';
        }
    }

    useEffect(() => {
        console.log({ userContractStatus });
    }, [userContractStatus])

    return (
        <>
            <div className="chime-container">
                {replyTxId && threading &&
                    <div className="weave">
                        <ViewColumnSharpIcon color='warning' fontSize='large' />
                    </div>
                }

                {/* Chime Card Body */}
                <div id="chime">

                    {/* Chime Author Header */}
                    <CardHeader
                        id='chime-header'
                        avatar={
                            <div id="avatar" onClick={() => redirectToProfile(authorPrincipal)}>
                                <Avatar className="deruptar-profile" alt="deruptar"
                                    authorPrincipal={authorPrincipal}
                                    userSettings={userSettings}
                                    profile={false}
                                    setShowUserContractDeployModal={setShowUserContractDeployModal}
                                    setShowAdvisoryModal={setShowAdvisoryModal}
                                    setShowWoopsModal={setShowWoopsModal}
                                    userContractStatus={userContractStatus}
                                    loadOutData={loadOutData}
                                    setLoadOutData={setLoadOutData}
                                />
                                <div id="ogcheck-thread-container">
                                    <ViewOGBadge txId={txId} authorPrincipal={authorPrincipal} userSettings={userSettings} />
                                </div>
                            </div>
                        }
                        action={<IconButton aria-label="options" onClick={() => handleMoreOptionsClick(contenttxId, authorPrincipal)} > <MoreVertIcon id="options" /> </IconButton>}
                        title={<div id="name"> {authorName} </div>}
                        subheader={<div id="address"> {authorPrincipal.substring(0, 5) + '...' + authorPrincipal.substring(authorPrincipal.length - 5)} </div>}
                    />

                    {/* Chime Attachment */}
                    {((attachmentUrl || thumbnailUrl)) &&
                        < Attachments

                            index={index} txId={contenttxId}
                            type={{ imageType, audioType, videoType }}
                            content={content}
                            attachmentUrl={attachmentUrl} thumbnailUrl={thumbnailUrl}
                            ChimeAuthorPrincipal={authorPrincipal}

                            playList={playList} setPlayList={setPlayList} mediaCurrentTime={mediaCurrentTime}
                            selectedChimeTx={selectedChimeTx} setSelectedChimeTx={setSelectedChimeTx}
                            openMediaPlayer={openMediaPlayer} setOpenMediaPlayer={setOpenMediaPlayer}

                            replyCounts={replyCount} replied={replied}
                            likeCounts={likeCount} liked={liked}
                            disLikeCounts={disLikeCount} disliked={disliked}
                        />
                    }


                    {/* Chime Text */}
                    <CardContent id="content">
                        <Content content={content} />
                    </CardContent>

                    {/* Chime Action Footer */}
                    <CardActions disableSpacing id="derupt-buttons">

                        {/* Reply Icon Button */}
                        <ReplyMessageMenue
                            ChimeAuthorPrincipal={authorPrincipal}
                            Tx_ID={contenttxId}
                            setSelectedAuthorPrincipal={setSelectedAuthorPrincipal}
                            setTx_Id={setTx_Id}
                            setSentimentOptions={setSentimentOptions}
                            setShowReplyChimeModal={setShowReplyChimeModal}
                            setReplyOpen={setReplyOpen}
                            setOpenSnackBar={setOpenSnackBar}
                            setErrorMsg={setErrorMsg}
                            replyCounts={replyCount}
                            replied={replied}
                            userSettings={userSettings}
                            validate={validate}
                        />

                        {/* Like Icon Button*/}
                        <SentimentMenue
                            // Sentiments identifyer for either like or dislike
                            sentiment={true}

                            setOpenExtensionModal={setOpenExtensionModal}
                            setOpenSnackBar={setOpenSnackBar}
                            setOpenConfirmModal={setOpenConfirmModal}
                            setErrorMsg={setErrorMsg}
                            setExtensionAction={setExtensionAction}
                            setTx_Id={setTx_Id}

                            extensionAction={extensionAction}
                            Tx_ID={contenttxId}

                            counts={likeCount}
                            likedOrDisliked={liked}
                            // ftAmount={likeFtAmount}
                            validate={validate}
                            chimeAuthorPrincipal={authorPrincipal}
                            userSettings={userSettings}
                        />

                        {/* Dislike Icon Button */}
                        <SentimentMenue
                            // Sentiments identifyer for either like or dislike
                            sentiment={false}

                            setOpenExtensionModal={setOpenExtensionModal}
                            setOpenSnackBar={setOpenSnackBar}
                            setOpenConfirmModal={setOpenConfirmModal}
                            setErrorMsg={setErrorMsg}
                            setExtensionAction={setExtensionAction}
                            setTx_Id={setTx_Id}

                            extensionAction={extensionAction}
                            Tx_ID={contenttxId}

                            counts={disLikeCount}
                            likedOrDisliked={disliked}
                            // ftAmount={disLikeFtAmount}

                            validate={validate}
                            chimeAuthorPrincipal={authorPrincipal}
                            userSettings={userSettings}
                        />
                        {/* <button className="derupt-button" onClick={() => handleBoostClick(ChimeAuthorPrincipal)}><FaRocket size={24} /></button> */}
                        <button className="derupt-button" onClick={() => handleGiftClick(authorPrincipal, contenttxId)}><BiGift size={24} /></button>
                        <button className="derupt-button">
                            <Badge badgeContent={formatNumber(impressions)} max={999999999} color="warning" anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}><BiBarChart size={24} /></Badge>
                        </button>
                        <button className="derupt-button" onClick={() => handleShareClick(contenttxId)}><BiShareAlt size={24} /></button>

                    </CardActions>
                </div>

            </div>

            {/* Modals */}
            {showReplyChimeModal && (<ReplyChimeModal show={showReplyChimeModal} close={() => setShowReplyChimeModal(false)} setShow={setShowReplyChimeModal}
                setOpenExtensionModal={setOpenExtensionModal}
                selectedChimeAuthorPrincipal={selectedAuthorPrincipal}
                tx_Id={tx_Id} sentimentOptions={sentimentOptions}
                setOpenConfirmModal={setOpenConfirmModal}
                setTx_Id={setTx_Id}
                setReplyOpen={setReplyOpen}
                setErrorMsg={setErrorMsg}
                setOpenSnackBar={setOpenSnackBar}
                userSettings={userSettings}
            />)}

            {showGiftingModal && (<GiftingModal show={showGiftingModal} setShow={setShowGiftingModal} close={() => setShowGiftingModal(false)}
                setOpenExtensionModal={setOpenExtensionModal}
                authorPrincipal={selectedAuthorPrincipal}
                giftVia={txId}
                userSettings={userSettings}
            />)}

            {showSharingModal && (<SharingModal show={showSharingModal} close={() => setShowSharingModal(false)} txId={selectedTxId} />)}

            {showComingSoonModal && (<ComingSoonModal show={showComingSoonModal} setShow={setShowComingSoonModal} close={() => setShowComingSoonModal(false)} />)}

            {showMoreOptionsModal && (<MoreOptionsModal show={showMoreOptionsModal} setShow={setShowMoreOptionsModal} close={() => setShowMoreOptionsModal(false)}
                txId={selectedTxId}
                authorPrincipal={selectedAuthorPrincipal}
                userSettings={userSettings}
            />)}

            {openExtensionModal && (<ExtensionModal show={openExtensionModal} setShow={setOpenExtensionModal} close={() => setOpenExtensionModal(false)} authorPrincipal={authorPrincipal}
                filters={{
                    "send-message": false,
                    "like-message": true,
                    "dislike-message": true,
                    "favorable-reply-message": showReplyChimeModal,
                    "unfavorable-reply-message": showReplyChimeModal,
                    "gift-message": showGiftingModal
                }}
                setExtrasValues={setExtrasValues}
                extrasValues={extrasValues}
                extensionAction={extensionAction}
                setExtensionAction={setExtensionAction}
                setErrorMsg={setErrorMsg}
                setOpenSnackBar={setOpenSnackBar}
                setOpenConfirmModal={setOpenConfirmModal}
                txId={contenttxId}
                setTx_Id={setTx_Id}
            />)}

            {showAdvisoryModal && (<AdvisoryModal show={showAdvisoryModal} close={() => setShowAdvisoryModal(false)} />)}



            {/* Snack bar alert */}
            <Snackbar open={openSnackBar} autoHideDuration={6000} onClose={() => setOpenSnackBar(false)}>
                <Alert onClose={() => setOpenSnackBar(false)} severity="error" sx={{ width: '100%' }}> {errorMsg} </Alert>
            </Snackbar>
        </>
    )
}

export default ChimeCard;